import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';
import { createTelemetryObject, createTelemetry, TrackProps } from '@shared/core/analytics';

const category = 'accommodations';

export const mapTelemetry = createTelemetryObject({
  actions: {
    mapPinClicked: ({
      placeId,
      hotelName,
      from,
      isPreferred,
      listingType
    }: {
      listingType: AccommodationListingDTO['type'];
      placeId: Maybe<string>;
      hotelName?: string;
      from: string;
      isPreferred?: boolean;
    }): TrackProps => ({
      category,
      action: 'TravelMapInteracted',
      extraInfo: {
        name: `${category}_pinclicked`,
        placeId,
        hotelName,
        from,
        isPreferred,
        listingType
      }
    }),
    mapMarkerClicked: ({
      placeId,
      hotelName,
      from,
      listingType
    }: {
      listingType: AccommodationListingDTO['type'];
      placeId: Maybe<string>;
      hotelName?: string;
      from: 'miniMap' | 'fullMap';
    }): TrackProps => ({
      category,
      action: 'TravelMapInteracted',
      extraInfo: {
        name: `${category}_markerclicked`,
        placeId,
        hotelName,
        from,
        listingType
      }
    }),
    mapClicked: () => ({
      category: 'roomblock',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name: 'mapClicked'
      }
    }),
    mapInteraction: (name: 'pan' | 'zoom'): TrackProps => ({
      category,
      action: `TravelMapInteracted`,
      extraInfo: {
        name: `${category}_${name}`
      }
    }),
    searchThisAreaClicked: (): TrackProps => ({
      category,
      action: 'TravelMapInteracted',
      extraInfo: {
        name: `${category}_searchthisareaclicked`
      }
    })
  }
});

const { TelemetryProvider, useTelemetry } = createTelemetry(mapTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useMapTelemetry };
